import "./App.css";
import AllRoutes from "./Routes/AllRoutes";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Scrolltotop from "./helpers/ScrollToTop";

function App() {
  return (
    <>
      <Navbar />
      <Scrolltotop />
      <AllRoutes />
      <Footer />
    </>
  );
}

export default App;
